import React from "react";
import { ArrowLeftRight } from "lucide-react";
import { cn } from "@/lib/utils";

export default function GuestRiderBadge({
  className,
  iconClassName,
  label = "Inlånad",
  iconOnly = false,
  title,
}) {
  const effectiveTitle = title || label;

  return (
    <span
      title={effectiveTitle}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-amber-300/80 bg-amber-100/90 px-1.5 py-0.5 text-[10px] font-medium leading-none text-amber-950 dark:border-amber-300/55 dark:bg-amber-400/18 dark:text-amber-50",
        className
      )}
    >
      <ArrowLeftRight className={cn("h-3 w-3 shrink-0", iconClassName)} />
      {iconOnly ? null : <span>{label}</span>}
    </span>
  );
}
